import * as React from 'react'
import { graphql } from 'gatsby'

import SidebarLayout from '../uglib_components/sidebarLayout'

import Sidebar from '../uglib_components/sidebar'
import SidebarMenu from '../uglib_components/sidebarMenu'

const AlumniInActionOralHistoryPage = ( {location, data} ) => {
	const node = data.node;
	const title = node.title;

	const breadcrumbs = [
		{ 
			url: "",
			title: "Archives",
		},
		{ 
			url: "/archives/our-collections",
			title: "Our Collections",
		},
        { 
			url: "/archives/our-collections/regional-early-campus-history",
			title: "Regional & Early Campus History",
		},
		{ 
			url: "/archives/our-collections/regional-early-campus-history/alumni",
			title: "Alumni-in-Action Oral History Interviews",
		}
	]

	const sidebar = <>
		<Sidebar>
			<SidebarMenu url={location.pathname}/>
		</Sidebar>
	</>;

	let abstract = null;
	if (node.field_aia_abstract !== null) {
		abstract = <>
			<h2>Abstract</h2>
			<div dangerouslySetInnerHTML={{__html:node.field_aia_abstract.processed}}/>
		</>
	}

	let grad_year = null;
	if (node.field_aia_grad_year !== null) {
		grad_year = <>
			<h2>Graduation Year</h2>
			<div>{node.field_aia_grad_year}</div>
		</>
	}

	let interview_date = null;
	if (node.field_aia_interview_date !== null) {
		interview_date = <>
			<h2>Interview Date</h2>
			<div dangerouslySetInnerHTML={{__html:node.field_aia_interview_date.processed}}/>
		</>
	}

	let call_number = null;
	if (node.field_call_number !== null) {
		call_number = <>
			<h2>Call Number</h2>
			<div>{node.field_call_number}</div>
		</>
	}

	let transcript = null;
	if (node.body !== null) {
		transcript = <>
			<h2>Transcript</h2>
			<div dangerouslySetInnerHTML={{__html:node.body.processed}}/>
		</>
	}

	let audio = null;
	if (node.field_aia_audio !== null) {
		audio = <>
			<h2>Audio</h2>
			<a href={node.field_aia_audio.uri}>{node.title} interview</a>
		</>
	}

	return (
		<SidebarLayout breadcrumbs={breadcrumbs} sidebar={sidebar} title={title} bodyClass='oral-history'>

			{abstract}

			{grad_year}

			<h2>College</h2>
			<div>{node.field_aia_college}</div>

			{interview_date}

			<h2>Interviewer</h2>
			<div>{node.field_aia_interviewer}</div>

			{call_number}

			{audio}
			
			{transcript}
			
		</SidebarLayout>
    );
}

export const query = graphql`
  	query ($id: String) {
		node: nodeArchievsAlumniInAction(id: {eq: $id}) {
			title
			path {
			  alias
			}
			field_aia_about_the_interviewee {
			  processed
			}
			field_aia_abstract {
			  processed
			}
			field_aia_audio {
			  uri
			}
			field_aia_college
			field_aia_grad_year
			field_aia_interview_date {
			  processed
			}
			field_aia_interviewer
			field_call_number
			field_domain_all_affiliates
			body {
			  processed
			}
			id
		  }
		
  	}
`

export default AlumniInActionOralHistoryPage